import React from "react";
import TeamCard from "../../../components/cards/teamCard";

const Testimonials = ({ testimonials, groupProgram }) => {
  return (
    <>
      <h2 className="heading text-left py-5">Testimonials</h2>
      <div className="divide-y width-divider" />
      <div className="grid gap-2 grid-cols-1 md:grid-cols-2 py-2 text-sm  pt-5">
        {testimonials?.map((testimonial, index) => {
          const title = testimonial?.title || "Anonymous";
          const featuredImage =
            testimonial.testimonialReviewsFields?.thumbnailId?.gatsbyImage;
          const sourceFallbackImage =
            testimonial.testimonialReviewsFields?.thumbnailId?.sourceUrl;
          const testimonialDate = testimonial.date;
          const testimonialVideo =
            testimonial.testimonialReviewsFields?.rvwVideoEmbed;
          const content =
            testimonial?.testimonialReviewsFields?.rvwOverallReview ??
            testimonial?.content;
          const uri = testimonial.uri;

          return (
            <div
              key={index}
              className="flex items-top justify-center p-2 col-span-1 md:col-span-2 lg:col-span-1"
            >
              <TeamCard
                sourceUrl={sourceFallbackImage}
                title={title}
                bgImage={featuredImage}
                memberTitle={testimonialDate}
                content={content}
                uri={uri}
                memberVideo={testimonialVideo}
                groupProgram={groupProgram}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Testimonials;
